module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.data.title) ? _c('h4', [_vm._v(_vm._s(this.data.title))]) : _vm._e(), _vm._v(" "), _c('ReportFilterBadge', {
    attrs: {
      "metadata": this.data.metadata
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_c('tbody', [_c('tr', _vm._l((this.headers), function(header, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(header))])
  }), 0), _vm._v(" "), _vm._l((this.rowsByGroup), function(rows, group) {
    return _vm._l((rows), function(row, rowIndex) {
      return _c('tr', {
        key: group + '-' + rowIndex
      }, [(rowIndex === 0 && group !== '__ungrouped__') ? _c('td', {
        attrs: {
          "rowspan": rows.length
        }
      }, [_vm._v(_vm._s(group))]) : _vm._e(), _vm._v(" "), _vm._l((row), function(cell, cellIndex) {
        return _c('td', {
          key: cellIndex
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatterByDataType[cell.dataType](cell.value))
          }
        })])
      })], 2)
    })
  }), _vm._v(" "), (Object.keys(this.rowsByGroup).length === 0) ? [_c('tr', [_c('td', {
    attrs: {
      "colspan": this.headers.length
    }
  }, [_vm._v("Não há informações para este relatório no ano selecionado.")])])] : _vm._e()], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4ed9428","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/TableReport.vue
// module id = 780
// module chunks = 1